import { SnackbarKey } from 'notistack';
import { createAction } from '@reduxjs/toolkit';

import { PoolSnackbarData } from '../components/snackbars/pool-snackbar';

export const enqueueSnackbar = createAction<PoolSnackbarData>('snackbar/enqueue');
export const removeSnackbar = createAction<SnackbarKey>('snackbar/remove');
